<!-- <p>verify-incident-dialog works!</p> -->
<h1 *ngIf="data.screenSize === 1 || data.screenSize === 2" mat-dialog-title>
  Verify Incident -
  <strong
    ><i>{{ data.incidentName | uppercase }}</i></strong
  >
</h1>
<h5 *ngIf="data.screenSize === 3" mat-dialog-title>
  Verify Incident -
  <strong
    ><i>{{ data.incidentName | uppercase }}</i></strong
  >
</h5>
<mat-dialog-content class="mat-typography">
  <div class="text-lg font-semibold text-gray-800 mb-6">
    Please select the status to update
  </div>
  <div class="space-y-4">
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="grid grid-cols-1 md:grid-cols-2 gap-3"
      [(ngModel)]="selectedOption"
      (change)="onStatusChange($event.value)"
    >
      <mat-radio-button
        class="!items-start !min-h-0 w-full"
        *ngFor="
          let op of isAssignedToMe ? statusOptionsAssgined : statusOptions
        "
        [value]="op"
      >
        <div class="flex items-center ml-2 w-full">
          <span
            [ngClass]="getStatusTagClass(op)"
            class="flex items-center px-3 py-2 rounded-lg text-sm font-medium shadow-sm w-full max-w-full"
          >
            <mat-icon class="text-lg mr-2 !w-5 !h-5">{{
              getStatusIcon(op)
            }}</mat-icon>
            <span class="truncate">{{ op }}</span>
          </span>
        </div>
      </mat-radio-button>
    </mat-radio-group>

    <div
      *ngIf="errorMessage"
      class="bg-red-50 border border-red-200 rounded-lg p-4 mt-4"
    >
      <div class="flex items-center">
        <svg
          class="w-5 h-5 text-red-500 mr-2"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="text-red-700 text-sm">{{ errorMessage }}</span>
      </div>
    </div>

    <div
      *ngIf="selectedOption && !errorMessage"
      class="bg-green-50 border border-green-200 rounded-lg p-4 mt-4"
    >
      <div class="flex items-center">
        <svg
          class="w-5 h-5 text-green-500 mr-2"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="text-green-700 text-sm">
          Selected status: <strong>{{ selectedOption }}</strong>
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t bg-gray-50 px-6 py-4">
  <button
    mat-button
    mat-dialog-close
    class="mr-3 text-gray-600 hover:text-gray-800"
  >
    Cancel
  </button>
  <button
    [disabled]="!selectedOption || !!errorMessage"
    mat-raised-button
    (click)="saveChanges()"
    class="bg-blue-600 text-white hover:bg-blue-700 disabled:bg-gray-300 disabled:text-gray-500"
  >
    Save Changes
  </button>
</mat-dialog-actions>
